<template>
  <div class="pageContent">
    <el-row :span="24" class="serchContent" type="flex">
      <div>
         <el-button type="primary" size="small" @click="addTask" icon="el-icon-plus">新建统计任务 </el-button>
      </div>
       <el-select
        @clear="searchTaskList"
        clearable
        v-model="taskStatus"
        @change="searchTaskList"
        size="small"
        placeholder="请选择"
        class="mal10">
          <el-option label="关闭" :value="1"/>
          <el-option label="开启" :value="2"/>
      </el-select>
      <el-col class="search mal10"  >
        <el-col :span="8"><el-input  @keyup.13.native="searchTaskKeyUp" v-model.trim="taskName" placeholder="请输入任务名称" size="small" ></el-input></el-col>
          <el-button type="primary" size="small" icon="el-icon-search" @click="searchTaskList"></el-button>
      </el-col>
    </el-row>

    <div>
      <template v-if="dataList.length > 0" >
        <el-row :span="24" v-for="(rowItem,rowIndex) in Math.ceil(dataList.length/colCount)" :key="'rowId'+rowIndex">
          <el-col
          :span="8"
          v-for="(item,index) in dataList.slice(rowIndex * colCount, (rowIndex * colCount+colCount))"
            :key="'rowId'+rowIndex+'colId'+index">
            <el-col class="card">

              <el-col  @click.native="openDetail(item)" :span="14" >

                  <div class="ellipsis">
                    <el-tooltip :content="item.taskName" placement="top" effect="light">
                      <span>{{item.taskName}}</span>
                    </el-tooltip>
                  </div>

              </el-col>
              <el-col :span="10" class="tx_r">
                <span v-if="item.taskStatus.toString() === '2'" class="online">开启</span>
                <span v-else class="offline">关闭</span>
                <el-dropdown  trigger="click" @command="handleCommand">
                  <span class="el-dropdown-link">
                    <i class="el-icon-more transform-icon"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="{type:'update',taskDetail:item}">修改</el-dropdown-item>
                    <el-dropdown-item :command="{type:'delete',taskDetail:item}">删除</el-dropdown-item>
                    <el-dropdown-item :command="{type:'switch',taskDetail:item}">开关</el-dropdown-item>
                     <el-dropdown-item v-if="item.taskStatus.toString() === '2'"  :command="{type:'manual',taskDetail:item}">手动触发</el-dropdown-item>
                  </el-dropdown-menu>
              </el-dropdown>
              </el-col>

              <div @click="openDetail(item)">
              <el-col :span="24" >
                 <el-col :span="6">开始时间</el-col>
                <el-col style="padding-left:10px" :span="18">{{item.beginTime | tasktime}}</el-col>
              </el-col>
              <el-col :span="24">
                 <el-col :span="6">结束时间</el-col>
                  <el-col style="padding-left:10px" :span="18">{{item.endTime | tasktime}}</el-col>
              </el-col>
              <el-col :span="24">
                <el-col :span="6">描述</el-col>
                <el-col style="padding-left:10px" :span="18" v-if="item.taskDesc">
                  <el-tooltip :content="item.taskDesc" placement="top" effect="light">
                    <div class="ellipsis">{{item.taskDesc}}</div>
                  </el-tooltip>
                </el-col>
              </el-col>
              </div>
            </el-col>
          </el-col>
        </el-row>
      </template>
      <template v-else>
        <emptyView></emptyView>
      </template>

    </div>

    <!-- 分页管理 -->
      <el-row
        v-show="!listLoading"
        class="pagination-container"
        type="flex" justify="end"
        style="margin-top:10px"
        >
        <!-- 页码按钮的数量currenCurrent  sizeChange -->
        <Paging
          :pageParams="listQuery"
          :pageSize="[10,15,20,25,30,35]"
          :total="total" pagingStatus=""
          :pageQuery="listQuery"
          @changePage="handleCurrentChange"/>
      </el-row>

    <!-- 添加第一步/修改 -->
    <taskView
    v-if="currentStep === 1"
    :taskDetail="taskDetail?taskDetail:addTaskDetail"
    @nextStep="stepTo"
    @update="updateTaskList"
    @closeView="currentStep = -1"
    :operate="operate"
    :currentStep="currentStep"/>

      <!-- 步骤二弹窗 -->
    <addTaskStep2
     @nextStep="stepTo"
      :productList="productList"
      :taskDetail="taskDetail?taskDetail:addTaskDetail"
      :operate="operate"
      v-show="currentStep === 2"
      @closeView="currentStep = -1"
      :currentStep="currentStep"/>

 <!-- 步骤三设置定时 -->
      <taskTiming
       @nextStep="stepTo"
       :taskDetail="taskDetail?taskDetail:addTaskDetail"
        :operate="operate"
        v-show="currentStep === 3"
         @message="message"
       @update="updateTaskList"
      @closeView="currentStep = -1"
      :currentStep="currentStep"/>

<!-- 任务是否开启界面 -->
      <taskSwitchView
       :taskDetail="taskDetail"
        v-if="showTaskSwitch"
        @update="getTaskList"
        @closeView="showTaskSwitch = false"
      :showTaskSwitch="showTaskSwitch"/>
<!-- 任务详情 -->
      <taskDetailView
       :taskDetail="taskDetail"
        v-if="showTaskDetail"
        @closeView="showTaskDetail = false"
      :showTaskDetail="showTaskDetail"/>
<!-- 手动触发 -->
      <taskManualView
       :taskDetail="taskDetail"
        v-if="showManual"
        @message="message"
        @closeView="showManual = false"
      :showManual="showManual"/>

  </div>
</template>
<script>
import eventBus from '@/assets/js/eventBus'
import taskView from '@/components/dataList/taskView.vue'
import taskManualView from '@/components/dataList/taskManualView.vue'
import taskDetailView from '@/components/dataList/taskDetailView.vue'
import taskSwitchView from '@/components/dataList/taskSwitchView.vue'
import addTaskStep2 from '@/components/dataList/addTaskStep2.vue'
import taskTiming from '@/components/dataList/taskTiming.vue'
import { taskTaskList, delTask, taskDetail } from '@/api/dataStatistics'
import { productOptionsList } from '@/api/productRegistration'
import Paging from '@/components/paging'
import emptyView from '@/components/empty_view/empty'
export default {
  components: {
    taskView,
    addTaskStep2,
    taskTiming,
    taskSwitchView,
    taskDetailView,
    taskManualView,
    Paging,
    emptyView
  },
  data () {
    return {
      options: [{
        value: '开启',
        label: '2'
      }, {
        value: '关闭',
        label: '1'
      }],
      taskStatus: '',
      taskName: '',
      value: '',
      operate: '',
      showAddStep2: false,
      timingShow: false,
      listQuery: {
        page: 1,
        limit: 10
      },
      total: 0,
      listLoading: false, // 根据loading来进行显示/隐藏
      dataList: [],
      colCount: 3, // 每行显示的个数
      taskDetail: null,
      addTaskDetail: { // 用于添加设备时候把所有的属性修改到这个对象，最后做提交发起请求
        taskName: '',
        taskDesc: '',
        conditionType: ''
      },
      // 用于传给添加任务时步骤2的产品列表
      productList: [],
      showTaskSwitch: false, // 显示任务的开关界面
      showTaskDetail: false, // 任务详情
      showManual: false, // 手动触发
      currentStep: -1
    }
  },
  methods: {
    message (message) {
      this.$message({
        type: 'success',
        message: message
      })
    },
    openDetail (row) {
      // console.log('row:', row)
      // this.taskDetail = row
      // this.showTaskDetail = true

      // 重新初始化
      const params = {
        taskId: row.taskId
      }
      taskDetail(params).then(res => {
        eventBus.$emit('resetFields')// 重置所有步骤的form表单
        res = res.data
        if (res.code === 200) {
          this.taskDetail = res.data
          this.currentStep = 1
          this.operate = 'detail'
          console.log('详情接口this.taskDetail:', this.taskDetail)
        } else {
          this.$message.error('任务详情获取失败')
        }
      })
    },
    searchTaskKeyUp (e) {
      if (e.keyCode === 13) {
        this.getTaskList()
      }
    },
    searchTaskList () {
      // 搜索时候，把页面重置为第一页
      this.listQuery.page = 1
      this.getTaskList()
    },
    updateTaskList () {
      // 搜索条件以及分页重置
      this.listQuery.page = 1
      this.taskStatus = ''
      this.taskName = ''
      this.taskDesc = ''
      this.getTaskList()
    },
    getProductList () {
      productOptionsList({})
        .then(res => {
          this.productList = res.data.data
          console.log('this.productList:', this.productList)
        })
    },
    // 改变页码
    handleCurrentChange (val) {
      Object.assign(this.listQuery, val)
      // this.listQuery.page = val
      this.getTaskList()
    },
    getTaskList () {
      const params = {
        params: {
          pageNumber: this.listQuery.page,
          pageSize: this.listQuery.limit,
          taskName: this.taskName,
          taskStatus: this.taskStatus
        }
      }
      taskTaskList(params).then(res => {
        res = res.data
        console.log('任务列表数据：', res)
        if (res.code === 200) {
          if (res.data && res.data.list) {
            this.total = res.data.recordCount
            this.dataList = res.data.list
            console.log('this.dataList:', this.dataList)
          } else {
            this.total = 0
            this.dataList = []
          }
        } else {

        }
      })
    },
    stepTo (currentStep) {
      this.currentStep = currentStep
    },
    handleCommand (command) {
      console.log(command)
      this.taskDetail = command.taskDetail
      if (command.type === 'delete') {
        this.delTask()
        // this.listQuery.page = 1
      } else if (command.type === 'update') {
        this.currentStep = 1
        this.operate = 'update'
      } else if (command.type === 'switch') {
        // 开关
        this.showTaskSwitch = true
      } else if (command.type === 'manual') {
        // 手动触发
        this.showManual = true
      }
    },
    addTask () {
      // 重新初始化
      this.taskDetail = null
      this.addTaskDetail = {
        taskName: '',
        taskDesc: ''
      }
      eventBus.$emit('resetFields')// 重置所有步骤的form表单
      this.operate = 'add'
      this.currentStep = 1
    },
    confirmDel () {
      const params = {
        taskId: this.taskDetail.taskId
      }
      console.log('删除发送参数：', params)
      delTask(params).then(res => {
        res = res.data
        console.log('删除后返回数据：', res)
        if (res.code === 200) {
          this.$message({
            message: '任务删除成功',
            type: 'success'
          })
          console.log('总数', this.total)
          console.log('页码', this.listQuery.page)
          console.log('页数', this.listQuery.limit)
          console.log('求余数', this.total % this.listQuery.limit)
          console.log('求页码:')
          if (this.listQuery.page !== 1) {
            if (Math.ceil(this.total / this.listQuery.limit) === this.listQuery.page) {
              if (this.total % this.listQuery.limit === 1) {
                this.listQuery.page--
              }
            }
          }
          // 刷新列表
          this.getTaskList()
        } else {
          this.$message.error('任务删除失败')
        }
      })
    },
    delTask () {
      this.$confirm('确定删除此任务?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.confirmDel()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  },
  filters: {
    tasktime: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.slice(0, 10)
    }
  },
  computed: {
  },
  created () {
    this.getTaskList()
    this.getProductList()
  },
  beforeDestroy () {
  }
}
</script>
<style lang="less" scope>

.pageContent{
  .tx_r{
    text-align: right;
  }
  .mal10{
    margin-left: 10px;
  }
  .serchContent{
    margin-bottom: 10px;
    .el-button{
      // margin-left: 10px;
    }
    .search{
      flex: auto;
    }
    .iconPlus{
      font-size: 20px;
    }
  }
  .card{
    box-shadow: 0 1px 4px 0 rgba(0,0,0,.08);
    border: 1px solid #f2f2f2;
    padding-top: 15px;
    line-height: 30px;
    width: 98% !important;
    margin-right: 1%;
    margin-top: 10px;
    min-height: 120px;
    .el-dropdown-link {
      cursor: pointer;
    }
    .el-col{
      padding-left: 15px;
      padding-right: 15px;
      span:nth-child(even){
        margin-left: 20px;
      }
    }
     .checkData{
        color:rgb(0, 112, 204);
        font-size: 12px;
        cursor: pointer;
      }
      .time{
        color: #888888;
        font-size: 12px;
      }
      .offline{
        background:#f7f7f7 !important;
          color: #888888!important;
      }
      .online{
        background: #edfcf1 !important;
        color: #1E8E39 !important;
      }
      .transform-icon{
        margin-left: 10px;
        transform:rotate(90deg);
        -ms-transform:rotate(90deg); /* Internet Explorer */
        -moz-transform:rotate(90deg); /* Firefox */
        -webkit-transform:rotate(90deg); /* Safari 和 Chrome */
        -o-transform:rotate(90deg); /* Opera */
      }
  }
}
</style>
